import EmptyInterface from "@components/empty";
import CopyIcon from "@components/svgs/copy";
import ShareIcon from "@components/svgs/share";
import PrintIcon from "@components/svgs/print";
import SearchComponent from "@components/baseSearch";
import Drawer from "@components/drawer/Drawer";
import {ReactNode, useState} from "react";
import {useNavigate} from "react-router-dom";
import LMSList from "@features/employees/LmsList";
import AddCourse from "@features/employees/addcourse";


interface Candidate {
  id: number;
  name: string;
  age: number;
  email: string;
  status: "accepted" | "rejected";
  skills?: string;
  rating?: number;
  jobTitle?: string;
  dateAdded?: string;
  action?: ReactNode;
}

const data: Candidate[] = [
  {
    id: 1,
    name: "John Doe",
    age: 35,
    email: "john@example.com",
    status: "accepted",
  },
  {
    id: 2,
    name: "Jane Smith",
    age: 28,
    email: "jane@example.com",
    status: "rejected",
  },
  {
    id: 3,
    name: "Bob Johnson",
    age: 42,
    email: "bob@example.com",
    status: "accepted",
  },
  {
    id: 4,
    name: "Alice Williams",
    age: 31,
    email: "alice@example.com",
    status: "rejected",
  },
];

const TasksTab = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [edit, setEdit] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const toggleEdit = () => {
    setEdit(!edit);
  };

  const handleSearch = (value: string) => {
    setSearchQuery(value);
  };

  const navigate = useNavigate();

  const handleAddNewCandidate = () => {
    navigate("addcandidate");
  };

  return (
    <>
      <div className="py-8 bg-custom_faded_blue flex flex-col px-4">
        <div className={`mt-2 rounded-xl ${data && "bg-white"}`}>
          <div className="px-5 py-4 flex justify-between items-center">
            <h1 className="text-2xl font-outfit font-semibold">Course</h1>
            <div className="flex gap-x-3 items-center">
              <SearchComponent
                placeholder="Find tasks..."
                value={searchQuery}
                onChange={handleSearch}
                className="min-w-80"
              />
              <svg
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.875 8.37714C11.6429 8.37714 11.4204 8.46933 11.2563 8.63343C11.0922 8.79752 11 9.02008 11 9.25214C11 9.48421 11.0922 9.70677 11.2563 9.87086C11.4204 10.035 11.6429 10.1271 11.875 10.1271C12.1071 10.1271 12.3296 10.035 12.4937 9.87086C12.6578 9.70677 12.75 9.48421 12.75 9.25214C12.75 9.02008 12.6578 8.79752 12.4937 8.63343C12.3296 8.46933 12.1071 8.37714 11.875 8.37714ZM9.39875 8.37714C9.57953 7.8648 9.91477 7.42115 10.3583 7.10733C10.8018 6.79352 11.3317 6.625 11.875 6.625C12.4183 6.625 12.9482 6.79352 13.3917 7.10733C13.8352 7.42115 14.1705 7.8648 14.3512 8.37714H20.625C20.8571 8.37714 21.0796 8.46933 21.2437 8.63343C21.4078 8.79752 21.5 9.02008 21.5 9.25214C21.5 9.48421 21.4078 9.70677 21.2437 9.87086C21.0796 10.035 20.8571 10.1271 20.625 10.1271H14.3512C14.1705 10.6395 13.8352 11.0831 13.3917 11.397C12.9482 11.7108 12.4183 11.8793 11.875 11.8793C11.3317 11.8793 10.8018 11.7108 10.3583 11.397C9.91477 11.0831 9.57953 10.6395 9.39875 10.1271H8.375C8.14294 10.1271 7.92038 10.035 7.75628 9.87086C7.59219 9.70677 7.5 9.48421 7.5 9.25214C7.5 9.02008 7.59219 8.79752 7.75628 8.63343C7.92038 8.46933 8.14294 8.37714 8.375 8.37714H9.39875ZM17.125 13.6271C16.8929 13.6271 16.6704 13.7193 16.5063 13.8834C16.3422 14.0475 16.25 14.2701 16.25 14.5021C16.25 14.7342 16.3422 14.9568 16.5063 15.1209C16.6704 15.285 16.8929 15.3771 17.125 15.3771C17.3571 15.3771 17.5796 15.285 17.7437 15.1209C17.9078 14.9568 18 14.7342 18 14.5021C18 14.2701 17.9078 14.0475 17.7437 13.8834C17.5796 13.7193 17.3571 13.6271 17.125 13.6271ZM14.6488 13.6271C14.8295 13.1148 15.1648 12.6711 15.6083 12.3573C16.0518 12.0435 16.5817 11.875 17.125 11.875C17.6683 11.875 18.1982 12.0435 18.6417 12.3573C19.0852 12.6711 19.4205 13.1148 19.6012 13.6271H20.625C20.8571 13.6271 21.0796 13.7193 21.2437 13.8834C21.4078 14.0475 21.5 14.2701 21.5 14.5021C21.5 14.7342 21.4078 14.9568 21.2437 15.1209C21.0796 15.285 20.8571 15.3771 20.625 15.3771H19.6012C19.4205 15.8895 19.0852 16.3331 18.6417 16.647C18.1982 16.9608 17.6683 17.1293 17.125 17.1293C16.5817 17.1293 16.0518 16.9608 15.6083 16.647C15.1648 16.3331 14.8295 15.8895 14.6488 15.3771H8.375C8.14294 15.3771 7.92038 15.285 7.75628 15.1209C7.59219 14.9568 7.5 14.7342 7.5 14.5021C7.5 14.2701 7.59219 14.0475 7.75628 13.8834C7.92038 13.7193 8.14294 13.6271 8.375 13.6271H14.6488ZM11.875 18.8771C11.6429 18.8771 11.4204 18.9693 11.2563 19.1334C11.0922 19.2975 11 19.5201 11 19.7521C11 19.9842 11.0922 20.2068 11.2563 20.3709C11.4204 20.535 11.6429 20.6271 11.875 20.6271C12.1071 20.6271 12.3296 20.535 12.4937 20.3709C12.6578 20.2068 12.75 19.9842 12.75 19.7521C12.75 19.5201 12.6578 19.2975 12.4937 19.1334C12.3296 18.9693 12.1071 18.8771 11.875 18.8771ZM9.39875 18.8771C9.57953 18.3648 9.91477 17.9211 10.3583 17.6073C10.8018 17.2935 11.3317 17.125 11.875 17.125C12.4183 17.125 12.9482 17.2935 13.3917 17.6073C13.8352 17.9211 14.1705 18.3648 14.3512 18.8771H20.625C20.8571 18.8771 21.0796 18.9693 21.2437 19.1334C21.4078 19.2975 21.5 19.5201 21.5 19.7521C21.5 19.9842 21.4078 20.2068 21.2437 20.3709C21.0796 20.535 20.8571 20.6271 20.625 20.6271H14.3512C14.1705 21.1395 13.8352 21.5831 13.3917 21.897C12.9482 22.2108 12.4183 22.3793 11.875 22.3793C11.3317 22.3793 10.8018 22.2108 10.3583 21.897C9.91477 21.5831 9.57953 21.1395 9.39875 20.6271H8.375C8.14294 20.6271 7.92038 20.535 7.75628 20.3709C7.59219 20.2068 7.5 19.9842 7.5 19.7521C7.5 19.5201 7.59219 19.2975 7.75628 19.1334C7.92038 18.9693 8.14294 18.8771 8.375 18.8771H9.39875Z"
                  fill="#969EAE"
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="28"
                  height="28"
                  rx="5.5"
                  stroke="#657A93"
                  stroke-opacity="0.27"
                />
              </svg>

              <CopyIcon />
              <ShareIcon />
              <PrintIcon />
              <button
                onClick={toggleDrawer}
                className="bg-custom_deep_blue text-sm text-white px-4 py-2 rounded-lg flex items-center gap-3"
              >
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.5 8.5H8.5V14.5H6.5V8.5H0.5V6.5H6.5V0.5H8.5V6.5H14.5V8.5Z"
                    fill="white"
                  />
                </svg>
                <span>Add a new course</span>
              </button>
            </div>
          </div>
          <div className="">
            {data.length === 0 ? (
              <div className="mt-4 border border-custom_lighter_gray rounded-xl">
                <EmptyInterface
                  description="No tasks assigned yet..."
                  buttonText="Add a new task"
                  buttonAction={handleAddNewCandidate}
                />
              </div>
            ) : (
              <div>
                <div className="mt-4">
                  <LMSList toggleDrawer={toggleEdit} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Drawer
        drawerHeader="Add a Course"
        isOpen={isDrawerOpen}
        onClose={toggleDrawer}
      >
        <AddCourse />
      </Drawer>
      <Drawer drawerHeader="Update Course" isOpen={edit} onClose={toggleEdit}>
        <AddCourse />
      </Drawer>
    </>
  );
};

export default TasksTab;
